/**
 * TASK-567: Detect Stripe billing setup return from URL (feature-branch sync flow).
 */
export function parseBillingSetupReturn(searchParams) {
  const params =
    typeof searchParams === "string"
      ? new URLSearchParams(searchParams)
      : searchParams;

  const setupStatus = params.get("billing_setup");
  const sessionId = params.get("session_id") || "";
  const shopIdRaw = params.get("shopId");
  const shopId = shopIdRaw ? parseInt(shopIdRaw, 10) : null;

  const isSuccessReturn =
    setupStatus === "success" &&
    !!sessionId &&
    !sessionId.includes("CHECKOUT_SESSION_ID");

  return {
    isSuccessReturn,
    isCancelledReturn: setupStatus === "cancelled",
    sessionId: isSuccessReturn ? sessionId : null,
    shopId: shopId && !Number.isNaN(shopId) ? shopId : null,
  };
}

export function hadBillingSetupReturnOnLoad() {
  return parseBillingSetupReturn(window.location.search).isSuccessReturn;
}
